import React from 'react';
import TextBlock from '../Components/TextBlock';


const L12 = (props) => {
  return (
	<TextBlock name='Ліцензія на роздрібну торгівлю алкогольними напоями'>
	<section className="s-text">
		Відповідно до чинного законодавства України, торгівля алкогольними напоями, включаючи пиво, сидр, перрі підлягає ліцензуванню. Ліцензія видається безстроково. Отримати ліцензію можуть лише суб'єкти господарювання (юр. особи чи ФОП)<br/><br/>

		Ми допоможемо Вам отримати ліцензію в найкоротші строки. Вам не доведеться їздити по інстанціях, вистоювати черги і по кілька разів переподавати документи. 
<br/><br/>

		Для отримання ліцензії знадобиться:<br/>
		- сплатити державний збір (3000 гривень/квартал для кожного РРО чи ПРРО для міста або 160 гривень/квартал для сіл). <br/>
		- надати інформацію про зареєстрований РРО чи ПРРО. За потреби ми допоможемо зареєструвати Вам РРО чи ПРРО; <br/>
		- надати інформацію про приміщення, в якому буде здійснюватися торгівля;<br/>
		
	</section> 
	<section className="s-textb">
		Вартість наших послуг – 2000 гривень.<br/>
		Строк розгляду документів – 10 робочих днів після подання.
	</section> 
</TextBlock>

  );
}

const L13 = (props) => {
  return (
		<React.Fragment>
			<TextBlock name='Ліцензування пасажирських перевезень'>
                <section className="s-text">
                    Ліцензія для ФОП на перевезення пасажирів на такси і ліцензія на перевозку пасажирів легковим транспортом на  замовлення. <br/>
                    Для оформлення ліцензії знадобиться:<br/>
                    -Свідоцтво про реєстрацію транспортного засобу (тех. паспорт);<br/>
                    -Якщо ви не є власником автомобіля, то тимчасовий реєстраційний  талон (видається в ДАІ);
                </section> 
                <section className="s-textb">
                    Строк виконання 10-15 робочих днів.<br/>
                    Вартість наших послуг – 4000 гривен. <br/>
                    Державний збір – в розмірі одного прожиткового мінімуму для працездатної особи.
                </section> 
            </TextBlock>


			<TextBlock name='Транспорті ліцензії для ФОП з найманими працівниками або для перевезення пасажирів автобусами, маршрутками.'>
            <section className="s-textb">
                    Строк виконання 12-20 робочих днів.<br/>
                    Вартість наших послуг – 8000 гривень. <br/>
                    Державний збір – в розмірі одного прожиткового мінімуму для працездатної особи.
            </section> 
            </TextBlock>

		</React.Fragment>
  );
}

const L14 = (props) => {
  return (
	<TextBlock name='Транспорті ліцензії для юр. осіб для перевезення пасажирів автобусами, маршрутками.'>
	<section className="s-textb">
			Строк виконання 12-20 робочих днів.<br/>
			Вартість наших послуг – 8000 гривень. <br/>
			Державний збір – в розмірі одного прожиткового мінімуму для працездатної особи.
	</section> 
</TextBlock>

  );
}

const L15= (props) => {
  return (
	<TextBlock name='Ліцензія на роздрібну торгівлю тютюновими виробами'>
	<section className="s-text">
		Відповідно до законодавства України, торгівля тютюновими виробами і курильними сумішами підлягають ліцензуванню. Ліцензія видається безстроково. Отримати ліцензію можуть лише суб'єкти господарювання (юр. особи чи ФОП). 
<br/><br/>

		Ми допоможемо Вам отримати ліцензію в найкоротші строки. Вам не доведеться їздити по інстанціях, вистоювати черги і по кілька разів подавати документи. 
<br/><br/>

		Для отримання ліцензії знадобиться:<br/>
		- сплатити державний збір (700 гривень/квартал  для кожного РРО чи ПРРО для міста або 100 гривень/квартал для села). <br/>
		- надати інформацію про зареєстрований РРО чи ПРРО. За потреби ми допоможемо зареєструвати Вам РРО чи ПРРО; <br/>
		- надати інформацію про приміщення, в якому буде здійснюватися торгівля.
	</section> 
	<section className="s-textb">
		Вартість наших послуг – 2000 гривень.<br/>
		Строк розгляду документів – 10 робочих днів після подання.
	</section> 
</TextBlock>

  );
}



export { L12, L13, L14, L15 };


// WEBPACK FOOTER //
// ./src/Page/L12-L15.jsx